// ETHRAEON Ethos page · Phase S
// Slow reading page with generous spacing.
// (c) S. Jason Prohaska (ingombrante) 2024-2026

export function Ethos() {
  return (
    <main className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50">
      <article className="max-w-3xl mx-auto px-6 py-24 prose prose-neutral dark:prose-invert">
        <h1 className="text-4xl md:text-5xl font-light">Ethos</h1>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-medium">Humanitas ante Machinam</h2>
          <p>
            Humanity before the machine. This is the order. Decisions that matter belong to people.
            Systems serve, illuminate, and remember. They do not decide on the human's behalf.
          </p>
        </section>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-medium">Ethos in Practice</h2>
          <p>
            Calm, reversible, explainable, human-first. Every surface we ship is built to clarify a
            choice and then step back. We do not score users. We do not predict intent. We surface
            structured options and traceable reasoning.
          </p>
        </section>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-medium">Principles of Conduct</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Evidence over claims.</li>
            <li>Boundaries that breathe.</li>
            <li>Reflection without capture.</li>
            <li>Hold the silence until directly queried.</li>
          </ul>
        </section>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-medium">The Role of Each Demo</h2>
          <p>
            The Constitutional AI Shell holds the line. The Decision Insight Model widens the field
            of view. Recursive Witness OS keeps the record without watching the user. The Trinity
            composes them into one calm intention.
          </p>
        </section>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-medium">A Quiet Contract</h2>
          <p>
            You remain in control. We will not pressure, predict, or replace your judgment. The
            system needs a moment sometimes. So do you. We meet you there.
          </p>
        </section>
      </article>
    </main>
  );
}
